
import { defineComponent } from 'vue';
import { useEventBus } from '@white-label-helper/shared-composables';
import { getAppVariable } from '@white-label-helper/get-app-variable';
import { isAcq87AdditionalLanguagesEnabled } from '@white-label-plugin/launch-darkly';
import type { Locale } from '@white-label-types/internationalization';
import LanguageSelector from '../language-selector/language-selector.vue';
import ModalLanguageSelector from '../modal-language-selector/modal-language-selector.vue';
import { CavuButton } from 'ui-shared-components';
import { useScreenSize } from '@white-label-helper/shared-composables';

const eventBus = useEventBus();

const ACQ_87_GATED_LANGUAGE_CODES = ['da-DK', 'nb-NO', 'sv-SE', 'tr-TR'];

export default defineComponent({
  name: 'LanguageSelectorButton',
  components: {
    CavuButton,
    IconFlag: () => import('@white-label-icon/icon-flag'),
    LanguageSelector,
    ModalLanguageSelector,
  },

  setup() {
    const { isMobileResolution } = useScreenSize();
    return { isMobileResolution };
  },

  data() {
    return {
      modalOpen: false,
    };
  },

  computed: {
    availableLanguages() {
      const partnerLanguages = getAppVariable('languages') as Locale[];
      if (!partnerLanguages) return [];
      const partnerLanguageCodes = partnerLanguages.map((language) => language.code);
      const acq87Enabled = isAcq87AdditionalLanguagesEnabled();
      //@ts-ignore `locales` is part of nuxt-i18n, not recognised by typescript
      return this.$i18n.locales.filter((locale: Locale) => {
        if (!partnerLanguageCodes.includes(locale.code)) return false;
        if (!acq87Enabled && ACQ_87_GATED_LANGUAGE_CODES.includes(locale.code)) return false;
        return true;
      });
    },
    mobileDropdownIsOpen() {
      const languageSelector = this.$refs['languageSelector'];
      return languageSelector?.dropdownOpen;
    },
  },

  methods: {
    openModal() {
      this.modalOpen = true;
      eventBus.$emit('modalOpen', 'languageSelector');
    },
    showLanguageSelectorDropdown(value: boolean): void {
      const languageSelector = this.$refs['languageSelector'];
      if (languageSelector) languageSelector.dropdownOpen = value;
    },
    changeLanguage(language) {
      this.$i18n.setLocale(language.code);
    },
  },
});
